import * as Const from "../config/const";
import {getLanguage} from "../actions/commands";

export default class Projects {
    constructor(project){
        const language = getLanguage() === 'pt-br'
        this.id = project.pro_id
        this.title = language?project.pro_titulo_pt:project.pro_titulo_en
        this.description = language?project.pro_corpo_pt:project.pro_corpo_en
        this.src = Const.defaults.image_base_url+(language?project.pro_imagem_pt:project.pro_imagem_en)
        this.flag = `${Const.defaults.image_base_url}bandeiras/${(language?project.pro_imagem_pt:project.pro_imagem_en)}`
    }
}


// WEBPACK FOOTER //
// ./src/models/projects.js